import { render, staticRenderFns } from "./SearchSvcProviders.vue?vue&type=template&id=f022c000&"
import script from "./SearchSvcProviders.vue?vue&type=script&lang=js&"
export * from "./SearchSvcProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports